module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_5012.349fb927.png";